export const MobileRoutes = {
    vehicle: 'mobileDealSheet.vehicle',
    activity: 'mobileDealSheet.activities',
    contact: 'mobileDealSheet.contact',
    replacementDetails: 'mobileDealSheet.replacement-details',
    customerConnect: 'mobileDealSheet.customer-connect'
};
